import React, { useState, useEffect } from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { AylaButton } from '../Buttons'
import SavedStatusIcon from '~/components/shared/SavedStatusIcon'
import AylaResponseScrollArea from '~/components/ShortCourses/AylaResponseScrollArea'
import AylaLoading from '~/components/shared/AylaLoading'

const UpdateYourLinkedinPageThree = () => {
  const {
    formattedExerciseName,
    updateResponse,
    exerciseIndex,
    getResponse,
    saveExercise,
    embedExercise,
    requestAylaLinkedinFeedback,
  } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageThreeTranslations = t('pages.2')
  const [submitted, setSubmitted] = useState(false)
  const [aylaResponse, setAylaResponse] = useState('')
  const [displayedText, setDisplayedText] = useState('')
  const [index, setIndex] = useState(0)
  const [typingComplete, setTypingComplete] = useState(false)
  const [loadingStatus, setLoadingStatus] = useState(null)
  const showCursor = submitted && displayedText.length <= 0
  const [feedbackSelected, setFeedbackSelected] = useState(
    getResponse(exerciseIndex, 'ayla_review') || null,
  )

  const handleAylaStatement = async () => {
    setSubmitted(true)
    setLoadingStatus('loading')
    setAylaResponse('')
    setDisplayedText('')
    setIndex(0)
    setTypingComplete(false)
    try {
      if (embedExercise) {
        await saveExercise()
      }
      await getAylaData()
    } catch (error) {
      console.error('Error saving exercise:', error)
    }
  }

  const getAylaData = async () => {
    try {
      const data = await requestAylaLinkedinFeedback()
      setAylaResponse(data.response)
      setLoadingStatus('complete')
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const updateReview = (review) => {
    let currentReview = feedbackSelected
    currentReview = review
    updateResponse(exerciseIndex, 'ayla_review', currentReview)
    setFeedbackSelected(review)
  }

  function select(rating) {
    starOff(rating)
    starOn(rating)
    setRating(rating)
    removeText()
    addText(rating)
  }
  function show(rating) {
    starOff(rating)
    starOn(rating)
    removeText()
    addText(rating)
  }
  function revert() {
    let rating = getRating()
    starOff(0)
    starOn(rating)
    removeText()
    addText(rating)
  }
  function starOff(rating) {
    for (let i = 5; i > rating; i--) {
      document.getElementById('rating-' + i)?.classList.remove('selected')
    }
  }
  function starOn(rating) {
    for (let i = 1; i <= rating; i++) {
      document.getElementById('rating-' + i)?.classList.add('selected')
    }
  }
  function removeText() {
    for (let i = 1; i <= 5; i++) {
      document.getElementById('rating-' + i)?.classList.remove('selected-text')
    }
  }
  function addText(rating) {
    document.getElementById('rating-' + rating)?.classList.add('selected-text')
  }
  function setRating(rating) {
    updateReview(rating)
  }
  function getRating() {
    return feedbackSelected
  }

  useEffect(() => {
    if (typingComplete) {
      updateResponse(exerciseIndex, 'ayla_feedback', aylaResponse)
    }
  }, [typingComplete, displayedText])

  return (
    <div className="questions md:min-h-80">
      <div className="flex w-full flex-col">
        <AylaButton containerClassName={'!mt-2'} onClick={handleAylaStatement}>
          {t('start_exercise.lets_go')}
          <SavedStatusIcon loadingStatus={loadingStatus} />
        </AylaButton>
        {loadingStatus === 'complete' && (
          <AylaResponseScrollArea
            showBorder={submitted}
            showCursor={showCursor}
            aylaResponse={aylaResponse}
            typingComplete={typingComplete}
            setTypingComplete={setTypingComplete}
            displayedText={displayedText}
            setDisplayedText={setDisplayedText}
            index={index}
            setIndex={setIndex}
            className="mb-4 h-60"
          />
        )}
        {loadingStatus === 'loading' && (
          <div className="flex items-center justify-center">
            <AylaLoading />
          </div>
        )}
      </div>
      <p>{typingComplete && pageThreeTranslations.review}</p>
      {typingComplete && (
        <div className="flex flex-row items-center justify-center gap-2">
          <div className="pr-4">
            Help us improve Ayla by rating your experience.
          </div>
          <div
            id="rating-1"
            className="rating ga-trackable"
            onClick={() => (getRating() === 1 ? updateReview(0) : select(1))}
            onMouseOver={() => show(1)}
            onMouseOut={() => revert()}
          >
            <i className="el-icon-star"></i>
            <br />
          </div>
          <div
            id="rating-2"
            className="rating ga-trackable"
            onClick={() => (getRating() === 2 ? updateReview(0) : select(2))}
            onMouseOver={() => show(2)}
            onMouseOut={() => revert()}
          >
            <i className="el-icon-star"></i>
            <br />
          </div>
          <div
            id="rating-3"
            className="rating ga-trackable"
            onClick={() => (getRating() === 3 ? updateReview(0) : select(3))}
            onMouseOver={() => show(3)}
            onMouseOut={() => revert()}
          >
            <i className="el-icon-star"></i>
            <br />
          </div>
          <div
            id="rating-4"
            className="rating ga-trackable"
            onClick={() => (getRating() === 4 ? updateReview(0) : select(4))}
            onMouseOver={() => show(4)}
            onMouseOut={() => revert()}
          >
            <i className="el-icon-star"></i>
            <br />
          </div>
          <div
            id="rating-5"
            className="rating ga-trackable"
            onClick={() => (getRating() === 5 ? updateReview(0) : select(5))}
            onMouseOver={() => show(5)}
            onMouseOut={() => revert()}
          >
            <i className="el-icon-star"></i>
            <br />
          </div>
        </div>
      )}
    </div>
  )
}
export default UpdateYourLinkedinPageThree
